/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react';
import { useLatestCoverage } from '../hooks/fotbollplay';
import VideoCard from './FotbollPlay/VideoCard';
import { DataContext } from '../context/data-context';

function LatestCoverage() {
  const { league, currentSeason } = useContext(DataContext);
  const [videos] = useLatestCoverage(8);

  if (videos?.length > 0) {
    return (
      <section className="row mb-5">
        <div className="col-12 d-flex px-sm-4 align-items-center mb-4">
          <h2 className="heading-h6 heading-sm-h3 flex-grow-1">
            SENASTE SAMMANDRAGEN
          </h2>
          <a
            className="button button--primary ml-auto"
            href={`https://fotbollplay.se/ligamatcher/${league}/${currentSeason}`}
            title="Fotbollplay"
            target="_blank"
          >
            <span className="me-1 d-inline-block">Se mer</span>
            <span className="d-none d-sm-inline-block">från fotboll Play</span>
          </a>
        </div>
        <div className="col-12 px-md-0">
          <div className="video__container video__container--carousel">
            {videos.map((v) => (
              <VideoCard key={v.id} video={v} />
            ))}
          </div>
        </div>
      </section>
    );
  }

  return null;
}

export default LatestCoverage;
